// componnet
import BoxProduct from "../../components/superAdminPanel/Product/BoxProduct";
import EditProduct from "../../components/superAdminPanel/Product/EditProduct";
import Loader from "../../components/kits/Loader";
import useAxios from "../../services/useAxios";
import FilterProduct from "../../components/superAdminPanel/Product/FilterProduct";
import AddProduct from "../../components/superAdminPanel/Product/AddProduct";
import DeleteProduct from "../../components/superAdminPanel/Product/DeleteProduct";
import StopProduct from "../../components/superAdminPanel/Product/StopProduct";
// react
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import ReactPaginate from "react-paginate";

// style
export default function RequestedProducts() {
  const [allProductTags, setAllProductTags] = useState([]);
  const { execute: getListProduct } = useAxios(
    "superadminapi/get_list_product"
  );

  const { execute: productData } = useAxios(
    "superadminapi/get_add_edit_product_data"
  );
  const { execute: updateProduct } = useAxios("api/Update_products");

  const [isLoading, setIsLoading] = useState(false);
  const [allLeader, setAllLeader] = useState([]);
  const [allUserTag, setAllUserTag] = useState([
    { label: "", value: "", id: 0, default_price: 0, default_need_time: 0 },
  ]);
  const [selectedItem, setSelectedItem] = useState(1);
  const [updater, setUpdater] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState();
  const [todos, setTodos] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const usersPerPage = 12;
  const pageVisited = pageNumber * usersPerPage;
  const pageCountt = Math.ceil(total / 10);
  const changePage = ({ selected, ...props }) => {
    setPageNumber(selected);
    console.log("setPageNumber", props);
    console.log("setPageNumber", pageNumber);
    console.log("setPageNumber", selected);
  };
  console.log("selected", selectedItem);
  console.log("total", total);
  const [otherInfo, setOtherInfo] = useState({
    available_order_option_ids: [],
    title: "",
    cat_id: "",
    default_price: "",
    default_weight_from: [],
    default_weight_to: "",
    products__id: "",
    line_id: [],
    sub_line_id: [],
    path: "",
    main_cover_file_id: "",
    discription: "",
    filename: [],
    send_type: "",
    status: [],
    sum_product_rate: "",
    count_product_rate: "",
    total_inventory: "",
    total_supplier_count: "",
    best_supplier_id: "",
  });

  useEffect(() => {
    async function getProduct(page, count) {
      setIsLoading(true);
      let myFormData = new FormData();

      myFormData.append("page", page);
      myFormData.append("count", count);
      myFormData.append("product_status", -10);

      if (filterInputs.title !== "") {
        myFormData.append("keyword", filterInputs.title);
      }
      if (filterInputs.order_count_from !== "") {
        myFormData.append("order_count_from", filterInputs.order_count_from);
      }
      if (filterInputs.order_count_to !== "") {
        myFormData.append("order_count_to", filterInputs.order_count_to);
      }
      if (filterInputs.unit_price_from !== "") {
        myFormData.append("unit_price_from", filterInputs.unit_price_from);
      }
      if (filterInputs.unit_price_to !== "") {
        myFormData.append("unit_price_to", filterInputs.unit_price_to);
      }
      if (filterInputs.supplier_count_from !== "") {
        myFormData.append(
          "supplier_count_from",
          filterInputs.supplier_count_from
        );
      }
      if (filterInputs.supplier_count_to !== "") {
        myFormData.append("supplier_count_to", filterInputs.supplier_count_to);
      }
      if (filterInputs.add_to_basket_count_from !== "") {
        myFormData.append(
          "add_to_basket_count_from",
          filterInputs.add_to_basket_count_from
        );
      }
      if (filterInputs.add_to_basket_count_to !== "") {
        myFormData.append(
          "add_to_basket_count_to",
          filterInputs.add_to_basket_count_to
        );
      }
      if (filterInputs.total_inventory_count_from !== "") {
        myFormData.append(
          "total_inventory_count_from",
          filterInputs.total_inventory_count_from
        );
      }
      if (filterInputs.total_inventory_count_to !== "") {
        myFormData.append(
          "total_inventory_count_to",
          filterInputs.total_inventory_count_to
        );
      }
      await getListProduct(myFormData).then((res) => {
        setCustomers(res.list);
        setTotal(res.total);
        setIsLoading(false);
      });
    }
    getProduct(pageNumber + 1, 10);
    console.log("+++", pageNumber + 1);
  }, [updater, pageNumber]);
  console.log("pgn", pageNumber);
  console.log("pgv", pageVisited);
  console.log("++", customers);

  // get product
  // useEffect(() => {
  //   setIsLoading(true);
  //   async function loadPage() {
  //     let result = await getListProduct({});
  //     let x = result.list;

  //     setCustomers(x);
  //     setIsLoading(false);
  //   }
  //   loadPage();
  // }, [updater]);
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data",{});
      let data = await productData();
      let allProductTags = [];
      for (let index = 0; index < data.lines.length; index++) {
        let newObject = {};
        newObject.value = data.lines[index].id;
        newObject.label = data.lines[index].title;
        newObject.main_cat = data.lines[index].main_cat;
        newObject.parent_line_id = data.lines[index].parent_line_id;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
    }
    loadPage();
  }, []);

  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data",{});
      let data = await productData();
      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject = data.cats[index];

        allLeader.push(newObject);
      }

      setAllLeader(allLeader);
    }
    loadPage();
  }, []);
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data",{});
      let data = await productData();

      var allUserTagTemp = [];
      for (let index = 0; index < data.avb_options.length; index++) {
        let newObject = {};
        newObject.value = data.avb_options[index].id;
        newObject.label = data.avb_options[index].title;
        newObject.default_need_time = data.avb_options[index].default_need_time;
        newObject.default_price = data.avb_options[index].default_price;
        allUserTagTemp.push(newObject);
      }
      setAllUserTag(allUserTagTemp);
    }
    loadPage();
  }, []);
  let chars = customers;
  console.log("chars", chars);
  const [filterInputs, setFilterInputs] = useState({
    title: "",
    order_count_from: "",
    order_count_to: "",
    unit_price_from: "",
    unit_price_to: "",
    supplier_count_from: "",
    supplier_count_to: "",
    add_to_basket_count_from: "",
    add_to_basket_count_to: "",
    total_inventory_count_from: "",
    total_inventory_count_to: "",
  });
  // filter product
  async function search() {
    setIsLoading(true);
    let myFormData = new FormData();

    if (filterInputs.title !== "") {
      myFormData.append("keyword", filterInputs.title);
    }
    if (filterInputs.order_count_from !== "") {
      myFormData.append("order_count_from", filterInputs.order_count_from);
    }
    if (filterInputs.order_count_to !== "") {
      myFormData.append("order_count_to", filterInputs.order_count_to);
    }
    if (filterInputs.unit_price_from !== "") {
      myFormData.append("unit_price_from", filterInputs.unit_price_from);
    }
    if (filterInputs.unit_price_to !== "") {
      myFormData.append("unit_price_to", filterInputs.unit_price_to);
    }
    if (filterInputs.supplier_count_from !== "") {
      myFormData.append(
        "supplier_count_from",
        filterInputs.supplier_count_from
      );
    }
    if (filterInputs.supplier_count_to !== "") {
      myFormData.append("supplier_count_to", filterInputs.supplier_count_to);
    }
    if (filterInputs.add_to_basket_count_from !== "") {
      myFormData.append(
        "add_to_basket_count_from",
        filterInputs.add_to_basket_count_from
      );
    }
    if (filterInputs.add_to_basket_count_to !== "") {
      myFormData.append(
        "add_to_basket_count_to",
        filterInputs.add_to_basket_count_to
      );
    }
    if (filterInputs.total_inventory_count_from !== "") {
      myFormData.append(
        "total_inventory_count_from",
        filterInputs.total_inventory_count_from
      );
    }
    if (filterInputs.total_inventory_count_to !== "") {
      myFormData.append(
        "total_inventory_count_to",
        filterInputs.total_inventory_count_to
      );
    }
    myFormData.append("page", pageNumber + 1);
    myFormData.append("count", 10);

    // axios
    //   .post(
    //     "https://sabadi.ir/api/superadminapi/get_list_product",
    //     myFormData
    //   )
    getListProduct(myFormData).then((res) => {
      console.log(
        "res",
        res.list.map((v) => v)
      );
      setCustomers(res.list);
      setIsLoading(false);
      setTotal(res.total);
    });
  }
  async function resetFilters() {
    setIsLoading(true);
    setFilterInputs({
      title: "",
      order_count_from: "",
      order_count_to: "",
      unit_price_from: "",
      unit_price_to: "",
      supplier_count_from: "",
      supplier_count_to: "",
      add_to_basket_count_from: "",
      add_to_basket_count_to: "",
      total_inventory_count_from: "",
      total_inventory_count_to: "",
    });

    setUpdater(!updater);
    setIsLoading(false);
  }
  const deleteHandler = (id) => {
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `product_status,-1`);
    myFormData.append("conditions", `id/=/${id}`);
    // axios
    //   .post(`https://sabadi.ir/api/api/Update_products`, myFormData)
    updateProduct(myFormData).then((data) => {
      if (data.status == 1) {
        toast.success("  کالا با موفقیت حذف شد");
        setUpdater(!updater);
        setIsLoading(false);
      } else {
        toast.error("  خطا در حذف کردن  کالا!");
        setIsLoading(false);
      }
    });
  };
  const stopHandler = (id) => {
    console.log("id", id);
    setIsLoading(true);
    let myFormData = new FormData();
    myFormData.append("keyvalues", `product_status,-2`);
    myFormData.append("conditions", `id/=/${id}`);
    // axios
    //   .post(`https://sabadi.ir/api/api/Update_products`, myFormData)
    updateProduct(myFormData).then((res) => {
      if (res.status == 1) {
        toast.success("  کالا با موفقیت متوقف شد");
        setIsLoading(false);
        setUpdater(!updater);
      } else {
        toast.error("  خطا در متوقف کردن  کالا!");
        setIsLoading(false);
      }
    });
  };
  const [itemProduct, setItemProduct] = useState([
    // {
    //   title: "vv",
    //   description: "weew",
    //   path: "",
    //   count_product_rate: "2",
    //   default_price: "12000",
    //   sum_product_rate: "2",
    //   total_inventory: "9000",
    //   total_supplier_count: "6",
    // },
    // {
    //   title: "vv",
    //   description: "weew",
    //   path: "",
    //   count_product_rate: "2",
    //   default_price: "12000",
    //   sum_product_rate: "2",
    //   total_inventory: "9000",
    //   total_supplier_count: "6",
    // },
  ]);
  return (
    <div className=" container w-100 h-100 d-flex flex-column">
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center flex-grow-1">
          <Loader width={40} />
        </div>
      ) : (
        <>
          {chars.length > 0 ? (
            chars.map((item, index) => {
              return (
                <div>
                  <BoxProduct
                    allUserTag={allUserTag}
                    setAllUserTag={setAllUserTag}
                    allLeader={allLeader}
                    setAllLeader={setAllLeader}
                    allProductTags={allProductTags}
                    setAllProductTags={setAllProductTags}
                    item={item}
                    key={item.id}
                    customers={customers}
                    todos={todos}
                    setTodos={setTodos}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    setCustomers={setCustomers}
                    index={index}
                    otherInfo={otherInfo}
                    setOtherInfo={setOtherInfo}
                    deleteHandler={() => deleteHandler(item.id)}
                    stopHandler={() => stopHandler(item.id)}
                  />
                </div>
              );
            })
          ) : (
            <p> محصول وجود ندارد</p>
          )}
        </>
      )}

      <div className=" d-flex justify-conteny-center">
        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          pageCount={pageCountt}
          onPageChange={changePage}
          containerClassName={"paginationBttn"}
          activeClassName={"paginationActive"}
          disabledClassName={"paginationDisabled"}
          nextLinkClassName={"nextBttn"}
          previousLinkClassName={"previousBttn"}
        />
      </div>

      <FilterProduct
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        search={search}
        resetFilters={resetFilters}
      />

      {/* <Filter /> */}
      {/* {ReactDOM.createPortal( */}

      {/* <AddProduct
        setIsLoading={setIsLoading}
        setCustomers={setCustomers}
        setUpdater={setUpdater}
        updater={updater}
      /> */}

      {/* , */}
      {/* document.getElementById("modals") */}
      {/* )} */}
      <EditProduct
        setIsLoading={setIsLoading}
        allProductTags={allProductTags}
        setAllProductTags={setAllProductTags}
        allLeader={allLeader}
        setAllLeader={setAllLeader}
        todos={todos}
        setTodos={setTodos}
        allUserTag={allUserTag}
        setAllUserTag={setAllUserTag}
        otherInfo={otherInfo}
        setOtherInfo={setOtherInfo}
        setUpdater={setUpdater}
        updater={updater}
        setCustomers={setCustomers}
        type="reqPro"
      />
      {/* <!--Modal Trash--> */}
      <DeleteProduct
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      <StopProduct
        index={selectedItem}
        customers={customers}
        stopHandler={stopHandler}
      />
      {/* <!--Modal Edit--> */}
    </div>
  );
}
